import { NocSizes } from "./NocSizes";
import { Order } from "./Order";

export class Return {
    id: number;
    action: String;
    trackingDate: Date;
    nocSize: NocSizes;
    order: Order;
    storeTicketNumber: string;
    observations?: string;  
    userNid: string;
    returnType: string;
    purchasePrice: number;
    
}